import React, { useEffect, useState } from "react"
import dayjs, { Dayjs } from "dayjs"
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useFormContext } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import styled from "styled-components"
import FormLabel from "~/components/atoms/FormLabel"
import ErrorField from "~/components/atoms/ErrorField"
import { checkIsNull, compareDates } from "~/utils/functions"
import ja from "date-fns/locale/ja"

registerLocale("ja", ja)

interface Props {
  name: string
  isConfirm?: boolean
  placeholder?: string
  displayFormat?: string
  disabled?: boolean
  value?: string
  className?: string
  validations?: {
    required?: boolean
    filterDate?: (date: Date) => boolean
  }
  error?: string
  onChange?: (params: string) => any | null
  isEdit?: boolean
  defaultValues?: Dayjs
}

export default function AcDatePicker(props: Props) {
  const {
    name,
    isConfirm = false,
    placeholder,
    displayFormat = "YYYY年MM月DD日",
    disabled = false,
    value,
    className,
    onChange,
    error,
    validations,
    isEdit,
    defaultValues = null,
  } = props
  const [date, setDate] = useState<Date | null>(null)
  const { register, setValue, formState } = useFormContext()
  const options = {}
  if (validations?.required) {
    Object.assign(options, {
      required: `${error || name}を入力してください`,
      valueAsDate: true,
    })
  }

  useEffect(() => {
    const inputDate = checkIsNull(value) ? defaultValues : dayjs(value)
    setDate(inputDate ? (inputDate.isValid() ? inputDate.toDate() : null) : null)
    if (isEdit) {
      setValue(name, inputDate?.toISOString)
    }
  }, [value])
  return isConfirm ? (
    <FormLabel>{date ? dayjs(date).format(displayFormat) : ""}</FormLabel>
  ) : (
    <div className={className}>
      <EXDatePicker
        {...register(name, options)}
        autoComplete={"off"}
        locale="ja"
        className={"datepicker"}
        placeholderText={placeholder}
        selected={date}
        onChange={(date) => {
          setDate(date)
          const data = date ? dayjs(date).toISOString() : null
          setValue(name, data, { shouldValidate: true })
          onChange?.apply(this, [data])
        }}
        timeInputLabel="時間:"
        showTimeInput={false}
        dateFormat={"yyyy年MM月dd日"}
        disabled={disabled}
        filterDate={validations?.filterDate}
      />
      <ErrorMessage
        errors={formState.errors}
        name={name}
        render={({ message }) => <ErrorField>{message}</ErrorField>}
      />
    </div>
  )
}

const EXDatePicker = styled(DatePicker)`
  cursor: pointer;

  > input {
    font-size: 16px;
    display: block;
    width: 100%;
    border: 1px solid #bdbfc8;
    padding: 13px 10px;
    border-radius: 4px;
    background-color: #ffffff;
  }

  &.datepicker {
    font-size: 16px;
    display: block;
    width: 100%;
    border: 1px solid #bdbfc8;
    padding: 13px 10px;
    border-radius: 4px;
    background-color: #ffffff;
    ${(props) => props.disabled && `background-color: #f6f6f6 !important;`}
  }

  &.datepicker input {
    padding: 13px 35px 13px 13px;
    border: 1px solid #bdbfc8;
  }
`
